// @flow

import { DISPLAY_CONFIRMATION, DISMISS_CONFIRMATION, CONFIRM_DEFAULT } from './constants';

import type { Action, State } from '../types';

const initialState: State = {
  visible: false,
  kind: CONFIRM_DEFAULT
};

const reducer = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case DISPLAY_CONFIRMATION:
      return {
        ...state,
        visible: true,
        kind: action.kind
      };

    case DISMISS_CONFIRMATION:
      return {
        ...state,
        visible: false
      };

    default:
      return state;
  }
};

export default reducer;
